import { mapEventMetadata, NovaEventingProvider } from '@nova/react';
import { AdaptiveCardNovaComponent } from '@office-start/adaptive-card-renderer';
import React from 'react';
import { useAppHostAdaptiveCardNovaEventHandler } from './useAppHostAdaptiveCardNovaEventHandler';
export const AppHostAdaptiveCardNovaContextEventingProvider = ({ card, errorFallbackHandler, hostConfig, }) => {
    const novaEventing = useAppHostAdaptiveCardNovaEventHandler();
    return (React.createElement(NovaEventingProvider, { eventing: novaEventing, reactEventMapper: mapEventMetadata },
        React.createElement(AdaptiveCardNovaComponent, { card: card, errorFallbackHandler: errorFallbackHandler, hostConfig: hostConfig })));
};
//# sourceMappingURL=AppHostAdaptiveCardNovaEventingProvider.js.map